export enum PatternBoardAction {
    /** Create a new board under the current user, leaving the Pattern Board untouched. */
    SaveCopy = 'save_copy',
    /** Update the shared Pattern Board in place. Analytics admins only. */
    EditPatternBoard = 'edit_pattern_board'
}
